module.exports = __webpack_public_path__ + "img/c-13.7afcb458.jpg";